<template>
    <div>
        <div class="diagram-one-wrap" :style="{ height: winHeight - 100 + 'px' }" ref="total">
            <div id="main" ref="main" class="total-wrap">
                <div
                    id="canvas"
                    ref="canvas"
                    class="canvas-wrap"
                    :style="
                        `transform: scale(${scale});width:${width};height:${height};top:${top}px;left:${left}px`
                    "
                >
                    <img
                        class="bg-img"
                        src="../../../../assets/image/app/first_svg-01.svg"
                        alt
                        srcset
                    />
                    <!-- <div class="total-title">MO高压系统图</div> -->
                    <div
                        v-for="item in mo_datas"
                        :key="item.point_id"
                        class="data-wrap"
                        :style="`top:${item.top}%;left:${item.left}%;`"
                        @click="showDialog(item)"
                    >
                        <div class="data-item">
                            <div class="data-name red">ia</div>
                            <div class="data-number">
                                {{ item.ia }}
                                <span>A</span>
                            </div>
                        </div>
                        <div class="data-item">
                            <div class="data-name yellow">ib</div>
                            <div class="data-number">
                                {{ item.ib }}
                                <span>A</span>
                            </div>
                        </div>
                        <div class="data-item">
                            <div class="data-name green">ic</div>
                            <div class="data-number">
                                {{ item.ic }}
                                <span>A</span>
                            </div>
                        </div>
                    </div>
                    <div
                        v-for="item in me_datas"
                        :key="item.point_id"
                        class="data-wrap"
                        :style="`top:${item.top}%;left:${item.left}%;`"
                        @click="showDialog(item)"
                    >
                        <div class="data-item">
                            <div class="data-name red">ia</div>
                            <div class="data-number">
                                {{ item.ia }}
                                <span>A</span>
                            </div>
                        </div>
                        <div class="data-item">
                            <div class="data-name yellow">ib</div>
                            <div class="data-number">
                                {{ item.ib }}
                                <span>A</span>
                            </div>
                        </div>
                        <div class="data-item">
                            <div class="data-name green">ic</div>
                            <div class="data-number">
                                {{ item.ic }}
                                <span>A</span>
                            </div>
                        </div>
                    </div>
                    <div
                        v-for="item in temp_datas"
                        :key="item.point_id"
                        class="data-wrap"
                        :style="`top:${item.top}%;left:${item.left}%;`"
                        @click="showDialog(item)"
                    >
                        <div class="data-item-temp">
                            <div class="data-name-temp red">ta</div>
                            <div class="data-number-temp">
                                {{ item.ta }}
                                <span>℃</span>
                            </div>
                        </div>
                        <div class="data-item-temp">
                            <div class="data-name-temp yellow">tb</div>
                            <div class="data-number-temp">
                                {{ item.tb }}
                                <span>℃</span>
                            </div>
                        </div>
                        <div class="data-item-temp">
                            <div class="data-name-temp green">tc</div>
                            <div class="data-number-temp">
                                {{ item.tc }}
                                <span>℃</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <diagramDialog :dialogVisible.sync="dialogVisible" :id="data_id" />
    </div>
</template>
<script>
import diagramDialog from "./components/diagram-dialog.vue";
import * as api from "@/http/api-runtime.js";
export default {
    components: { diagramDialog },
    data() {
        return {
            left: "0",
            top: "-20",
            scale: 0.9,
            width: 1200,
            height: 1000,
            winHeight: 0,
            dialogVisible: false,
            data_id: "",
            data_temp_id: "",
            timer: null,
            mo_datas: [
                {
                    name: "906",
                    point_id: "1465522289318600704",
                    top: 55,
                    left: 2.5,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "904",
                    point_id: "1465522457094955008",
                    top: 55,
                    left: 10.5,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "9004-II",
                    point_id: "1465522626037325824",
                    top: 55,
                    left: 18,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "902",
                    point_id: "1465522801195655168",
                    top: 55,
                    left: 33.5,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "900",
                    point_id: "1465522969840230400",
                    top: 55,
                    left: 46,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "901",
                    point_id: "1465523116783476736",
                    top: 55,
                    left: 53,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "9004-I",
                    point_id: "1465523833300623360",
                    top: 55,
                    left: 74,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "903",
                    point_id: "1465523973612675072",
                    top: 55,
                    left: 81,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "905",
                    point_id: "1465524085181161472",
                    top: 55,
                    left: 89,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "右下901",
                    point_id: "6e50a6f36936476781e24cb984197adf",
                    top: 92,
                    left: 91,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "右下902",
                    point_id: "bf8e8b3939384c6c84881ddd561f3410",
                    top: 92,
                    left: 82,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "右下903",
                    point_id: "657315dce1fe452bae956adfa962e1c2",
                    top: 92,
                    left: 74.3,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "左下902",
                    point_id: "1628c53175a14c1094657e5fbe683aad",
                    top: 92,
                    left: 26,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "左下903",
                    point_id: "910e4da63a0a40d9afe08338bfa7d68d",
                    top: 92,
                    left: 35,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "左下904",
                    point_id: "9d97ed0be11c4b348a5364a9dadbf1de",
                    top: 92,
                    left: 43,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "左下905",
                    point_id: "191e37f359a942f9862aba87d02221d9",
                    top: 92,
                    left: 51,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "左下906",
                    point_id: "9f8cac3bec214a8e9ceca5419d556cc3",
                    top: 92,
                    left: 59,
                    ia: "",
                    ib: "",
                    ic: ""
                }
            ],
            temp_datas: [
                {
                    name: "AH2上出线 904",
                    point_id: "1483324257130811392",
                    top: 30,
                    left: 14,
                    ta: "",
                    tb: "",
                    tc: "",
                },
                {
                    name: "AH2下出线 904",
                    point_id: "1483324441747296256",
                    top: 41,
                    left: 14,
                    ta: "",
                    tb: "",
                    tc: "",
                },
                {
                    name: "AH5上出线 902",
                    point_id: "1483324618830811136",
                    top: 30,
                    left: 37,
                    ta: "",
                    tb: "",
                    tc: "",
                },
                {
                    name: "AH5下出线 902",
                    point_id: "1483324756437536768",
                    top: 41,
                    left: 37,
                    ta: "",
                    tb: "",
                    tc: "",
                },
                {
                    name: "AH8上出线 901",
                    point_id: "1483324975996768256",
                    top: 30,
                    left: 58,
                    ta: "",
                    tb: "",
                    tc: "",
                },
                {
                    name: "AH8下出线 901",
                    point_id: "1483325156175679488",
                    top: 41,
                    left: 58,
                    ta: "",
                    tb: "",
                    tc: "",
                },
                {
                    name: "AH11上出线 903",
                    point_id: "1483325265777037312",
                    top: 30,
                    left: 85,
                    ta: "",
                    tb: "",
                    tc: "",
                },
                {
                    name: "AH11下出线 903",
                    point_id: "1483325385742520320",
                    top: 41,
                    left: 85,
                    ta: "",
                    tb: "",
                    tc: "",
                }
            ]
        };
    },
    created() {
        if (window.innerHeight) this.winHeight = window.innerHeight;
        else if (document.body && document.body.clientHeight)
            this.winHeight = document.body.clientHeight;
    },

    mounted() {
        this.zoom();
        this.drag();
        this.setTimer();
        // 获取mo实时电数据
        this.getMoElecData();
        // 获取mo实时温度数据
        this.getMoTempData();
        // 获取me实时电数据
     //   this.getNewestPowerApi();
    },
    methods: {
        setTimer() {
            if (this.timer) {
                clearInterval(this.timer);
            }
            this.timer = setInterval(() => {
                // 获取mo实时电数据
                this.getMoElecData();
                // 获取mo实时温度数据
                this.getMoTempData();
                // 获取me实时电数据
            //    this.getNewestPowerApi();
            }, 1000 * 60);
        },
        /**
        * @description: 获取mo实时电数据
        */
        getMoElecData() {
            let pointIds = [];
            this.mo_datas.forEach(item => {
                pointIds.push(item.point_id);
            });
            api.getDataAll(pointIds).then(res => {
                let valueJson = res.bus_json;
                this.mo_datas.forEach(item => {
                    let point = valueJson[item.point_id];

                    item.ia = point && point["a_a"] && this.fixedString(point["a_a"], 2);
                    item.ib = point && point["a_b"] && this.fixedString(point["a_b"], 2);
                    item.ic = point && point["a_c"] && this.fixedString(point["a_c"], 2);
                })
            })
        },
        /**
        * @description: 获取mo实时温度数据
        */
        getMoTempData() {
            let pointIds = [];
            this.temp_datas.forEach(item => {
                pointIds.push(item.point_id);
            });
            api.getDataAll(pointIds).then(res => {
                let valueJson = res.bus_json;
                this.temp_datas.forEach(item => {
                    let point = valueJson[item.point_id];
                    let ta, tb, tc = '';
                    if(item.point_id == '1483324257130811392') {
                        ta = 'A1';
                        tb = 'B1';
                        tc = 'C1';
                    } else if (item.point_id == '1483324441747296256') {
                        ta = 'A2';
                        tb = 'B2';
                        tc = 'C2';
                    } else if (item.point_id == '1483324618830811136') {
                        ta = 'A3';
                        tb = 'B3';
                        tc = 'C3';
                    } else if (item.point_id == '1483324756437536768') {
                        ta = 'A4';
                        tb = 'B4';
                        tc = 'C4';
                    } else if (item.point_id == '1483324975996768256') {
                        ta = 'A5';
                        tb = 'B5';
                        tc = 'C5';
                    } else if (item.point_id == '1483325156175679488') {
                        ta = 'A6';
                        tb = 'B6';
                        tc = 'C6';
                    } else if (item.point_id == '1483325265777037312') {
                        ta = 'A7';
                        tb = 'B7';
                        tc = 'C7';
                    } else if (item.point_id == '1483325385742520320') {
                        ta = 'A8';
                        tb = 'B8';
                        tc = 'C8';
                    }
                    item.ta = point && point[ta] && this.fixedString(point[ta], 0);
                    item.tb = point && point[tb] && this.fixedString(point[tb], 0);
                    item.tc = point && point[tc] && this.fixedString(point[tc], 0);
                })
            })
        },
        /**
        * @description: 获取me实时电数据
        */
        getNewestPowerApi() {
            // 逐个调用
            this.me_datas.forEach(item => {
                api.getNewestPower({ point_id: item.point_id }).then(res => {
                    item.ia = res.bus_json["a_a"] && this.fixedString(res.bus_json["a_a"], 2);
                    item.ib = res.bus_json["a_b"] && this.fixedString(res.bus_json["a_b"], 2);
                    item.ic = res.bus_json["a_c"] && this.fixedString(res.bus_json["a_c"], 2);
                })
            });
        },
        /**
        * @description: 保留几位小数  number位数
        */
        fixedString(value, number) {
            let val = value + "";
            if (number == 0) {
                const arr = val.split(".");
                if (arr.length > 0) {
                    return arr[0];
                } else {
                    return "";
                }
            }
            return val.substring(0, val.indexOf(".") + (1 + number));

        },
        showDialog(item) {
            this.dialogVisible = true;
            this.data_id = item.point_id;
        },
        zoom() {
            let vm = this;
            if (navigator.userAgent.indexOf("Firefox") != -1) {
                //FF
                document.getElementById("main").addEventListener(
                    "DOMMouseScroll",
                    function (event) {
                        event = event || window.event;
                        if (event.detail > 0) {
                            vm.scale =
                                vm.scale > 0.2 ? vm.scale - 0.1 : vm.scale;
                        } else {
                            vm.scale += 0.1;
                        }
                        event.cancelBubble = true;
                        event.stopPropagation();
                        event.preventDefault();
                    },
                    false
                );
            } else {
                //非FF
                document.getElementById("main").onmousewheel = function (event) {
                    event = event || window.event;
                    if (event.deltaY > 0) {
                        vm.scale = vm.scale > 0.2 ? vm.scale - 0.1 : vm.scale;
                    } else {
                        vm.scale += 0.1;
                    }
                    event.cancelBubble = true;
                    event.stopPropagation();
                    event.preventDefault();
                };
            }
        },
        drag() {
            let oDiv = this.$refs.canvas;
            let vm = this;
            oDiv.onmousedown = function (en) {
                let ev = ev || event;
                let disX = en.clientX - oDiv.offsetLeft;
                let disY = en.clientY - oDiv.offsetTop;
                oDiv.onmousemove = function (en) {
                    let ev = ev || event;
                    if (
                        en.clientY > 0 &&
                        en.clientY < vm.$refs.main.clientHeight &&
                        en.clientX > 0 &&
                        en.clientX < vm.$refs.main.clientWidth
                    ) {
                        vm.top = en.clientY - disY;
                        vm.left = en.clientX - disX;
                    }
                };
                oDiv.onmouseup = function () {
                    oDiv.onmousemove = null;
                };
                return false;
            };
        },
    },
    destroyed() {
        clearInterval(this.timer);
    }
};
</script>
<style lang="scss" scoped>
.diagram-one-wrap {
    background-color: #09292f;
    width: 98%;
    overflow: hidden;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    .total-wrap {
        width: 100%;
        height: 100%;
        position: relative;
        cursor: move;
        .canvas-wrap {
            width: 100%;
            position: absolute;
            left: 0;
            top: 0;
        }
        .total-title {
            color: #fff;
            position: absolute;
            font-size: 24px;
            text-align: center;
            top: 1%;
            left: 50%;
            transform: translateX(-50%);
        }
        .bg-img {
            width: 100%;
        }

        .data-wrap {
            position: absolute;
            display: grid;
            transform: scale(1);
            cursor: pointer;

            .data-item {
                display: flex;
                margin-bottom: 0.2rem;

                .data-name {
                    align-self: center;
                    font-size: 1rem;
                    margin-right: 0.1rem;
                    width: 1rem;
                    text-align: right;
                    font-weight: bold;
                }

                .data-number {
                    font-size: 0.8rem;
                    width: 5rem;
                    text-align: right;
                   background-color: #0e4b69;
                  // margin-left: 0.5rem;
                    color: #fff;
                    height: 1rem;
                    line-height: 1rem;

                    .nowrap span {
                        display: inline-block;
                        margin-left: 0.2rem;
                        margin-right: 0.2rem;
                    }
                }

                .red {
                    color: #fe0101;
                }

                .yellow {
                    color: #fefa00;
                }

                .green {
                    color: #00b200;
                }
            }
            .data-item-temp {
                display: flex;
                margin-bottom: 0.3rem;

                .data-name-temp {
                    align-self: center;
                    font-size: 0.8rem;
                    margin-right: 0.1rem;
                    width: 0.8rem;
                    text-align: right;
                    font-weight: bold;
                }

                .data-number-temp {
                    font-size: 0.7rem;
                    width: 3rem;
                    text-align: right;
                     background-color: #0e4b69;
                    color: #fff;
                    height: 0.8rem;
                    line-height: 0.8rem;
                  //  margin-left:0.5rem;
                    .nowrap span {
                        display: inline-block;
                        margin-left: 0.2rem;
                        margin-right: 0.2rem;
                    }
                }

                .red {
                    color: #fe0101;
                }

                .yellow {
                    color: #fefa00;
                }

                .green {
                    color: #00b200;
                }
            }
        }
    }
}
</style>
